export const Env = {
  phone: '+7 (495) 125-09-05',
};



// WEBPACK FOOTER //
// ./src/env.js